import * as React from 'react';
import { Rectangle } from 'ark-common';
import { zIndex } from '../../constants';

export interface SimpleResizeSensorProps {
  onResize: (clientRect: Rectangle) => void;
}

// The parent element must styled with "position: relative".
export class SimpleResizeSensor extends React.PureComponent<SimpleResizeSensorProps, {}> {
  public element: HTMLIFrameElement | null = null;

  private handleLoad = (): void => {
    this.handleResize();

    const defaultView = this.element
      && this.element.contentDocument
      && this.element.contentDocument.defaultView;

    if (defaultView != null) {
      defaultView.addEventListener('resize', this.handleResize);
    }
  }

  private handleResize = (): void => {
    const { left, top, width, height } = this.element!.getBoundingClientRect();
    this.props.onResize({ width, height, x: left, y: top });
  }

  public componentDidMount(): void {
    this.element!.addEventListener('load', this.handleLoad);
    this.element!.src = 'about:blank';
  }

  public componentWillUnmount(): void {
    if (this.element != null) {
      this.element.removeEventListener('load', this.handleResize);

      const defaultView = this.element
        && this.element.contentDocument
        && this.element.contentDocument.defaultView;

      if (defaultView != null) {
        defaultView.removeEventListener('resize', this.handleResize);
      }
    }
  }

  public render() {
    const style: React.CSSProperties = {
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: zIndex.simpleResizeSensor,
      opacity: 0,
      border: 'none',
    };

    return <iframe style={style} ref={el => this.element = el} />;
  }
}
